<ng-container *ngFor="let item of dicasEstudo">
  <button class="button-dicasEstudo" mat-menu-item (click)="openDialog(item)">
    {{ item.ref }}
  </button>

  <mat-divider class="menu-divider"></mat-divider>
</ng-container>
